class NotificationModal {
  private element: HTMLElement;

  constructor(element: HTMLElement) {
    this.element = element;

    this.hideModal = this.hideModal.bind(this);
    this.onLayoutClick = this.onLayoutClick.bind(this);
    this.showModal = this.showModal.bind(this);
  }

  getModalActivityStatus() {
    return this.element.classList.contains(`notifications--show`);
  }

  showModal() {
    this.element.classList.add(`notifications--show`);

    setTimeout(() => {
      document.body.addEventListener(`click`, this.onLayoutClick);
    }, 200);
  }

  hideModal() {
    this.element.classList.remove(`notifications--show`);
    document.body.removeEventListener(`click`, this.onLayoutClick);
  }

  onLayoutClick(evt: Event) {
    const target = (evt.target as HTMLElement);

    if (!target.classList.contains(`notifications--show`) && !target.closest(`.notifications--show`)) {
      this.hideModal();
    }
  }
}

export {NotificationModal};
